import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { ProjectsReducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { ProjectStoreEffects } from './effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('project', ProjectsReducer),
    EffectsModule.forFeature([ProjectStoreEffects])
  ]
})
export class ProjectStoreModule { }
